import React from 'react';
import { type Provider, type SigninButton } from 'types/provider';

import { Button } from 'semantic';
import { useTranslation } from 'react-i18next';
import { OID_REDIRECT_BASE_API_URL } from 'utils/env';

export default function SignupButton({
  provider,
  button,
  onLoginClick,
  style,
  external = false,
}: {
  provider?: Provider;
  button?: SigninButton;
  onLoginClick?: () => void;
  style: React.CSSProperties;
  external?: boolean;
}) {
  const { i18n } = useTranslation();
  if (!provider || !button) {
    return null;
  }

  const { type, label, url, issuer, accountId } = button;

  const labelText = label && label[i18n.language];

  if (type === 'email-password') {
    return (
      <Button style={style} fluid onClick={onLoginClick} primary>
        {labelText}
      </Button>
    );
  }

  if (type === 'sso' && issuer && labelText) {
    return (
      <Button
        style={style}
        target={external ? '_blank' : undefined}
        fluid
        fullWidth
        as={'a'}
        href={`${OID_REDIRECT_BASE_API_URL}/1/auth/${provider.slug}/${issuer}/login`}
        rel="noopener noreferrer">
        {labelText}
      </Button>
    );
  }

  if (type === 'saml' && accountId && labelText) {
    return (
      <Button
        style={style}
        target={external ? '_blank' : undefined}
        fluid
        as={'a'}
        rel="noopener noreferrer"
        href={`${OID_REDIRECT_BASE_API_URL}/1/auth/login/sso/direct?spid=${accountId}`}>
        {labelText}
      </Button>
    );
  }

  if (type === 'custom-url' && url && labelText) {
    return (
      <Button
        style={style}
        target={external ? '_blank' : undefined}
        fluid
        as={'a'}
        href={url}
        rel="noopener noreferrer">
        {labelText}
      </Button>
    );
  }

  return null;
}
